<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <div class="loading" [class]="{'show': loaderService.loading}">
    <img src="assets/svg/loading.svg" />
    </div>
</ion-app>
